import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function HeroSection({ projectCount }) {
  return (
    <div
      className="relative h-screen w-full overflow-hidden flex items-center justify-center"
      data-testid="hero-section"
    >
      {/* Content */}
      <div className="relative z-[2] text-center max-w-4xl px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="section-label mb-6"
          data-testid="hero-label"
        >
          Expert en immobilier avec Brevet Fédéral de Courtier en immeubles.
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-5xl sm:text-6xl lg:text-8xl tracking-tighter leading-none font-light text-[#FAFAF8] mb-6"
          data-testid="hero-title"
        >
          Julien <span className="text-[#B07D62] italic">D'Amore</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-lg md:text-xl text-[#FAFAF8]/80 leading-relaxed tracking-wide max-w-xl mx-auto mb-10"
          data-testid="hero-subtitle"
        >
          20 ans d'expertise en Suisse romande.
        </motion.p>

        <motion.a
          href="#projets"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center gap-3 px-8 py-3.5 rounded-full bg-white/[0.06] border border-white/[0.12] text-[#FAFAF8] text-sm tracking-wider uppercase font-medium backdrop-blur-md hover:bg-white/[0.1] hover:border-[#B07D62]/30 hover:shadow-[0_0_30px_rgba(74,144,255,0.15)] transition-all duration-500"
          data-testid="hero-cta"
        >
          En savoir plus
        </motion.a>
      </div>

      {/* Scroll indicator — blue + clickable */}
      <motion.a
        href="#projets"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-[2] flex flex-col items-center gap-2 cursor-pointer group"
        data-testid="hero-scroll-btn"
      >
        <span className="text-[10px] tracking-[0.15em] uppercase text-[#B07D62] group-hover:text-[#6BABFF] transition-colors">
          Scroll
        </span>
        <motion.div
          animate={{ y: [0, 6, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <ChevronDown size={16} className="text-[#B07D62] group-hover:text-[#6BABFF] transition-colors" />
        </motion.div>
      </motion.a>
    </div>
  );
}
